import RespressoApi, {AppConfig, AuthSettings} from '../api/respresso-api';
import Vue from 'vue';
import Component from 'vue-class-component';
import ErrorHandler from './error-handler';
import {settingsModule} from '.././store/modules/settings/index';

@Component
export class SettingsServiceImpl extends Vue {
    private initProm: Promise<void> | undefined;

    public async init(): Promise<void> {
        if (!this.initProm) {
            const initPromFunc = async (): Promise<void> => {
                const [authSettings, appConfig] = await Promise.all([
                    ErrorHandler.tryRequest(() => RespressoApi.getAuthSettings()),
                    ErrorHandler.tryRequest(() => RespressoApi.getAppConfig())
                ]);
                if (authSettings) {
                    settingsModule.SET_AUTH_SETTINGS(authSettings);
                }
                if (appConfig) {
                    settingsModule.SET_APP_CONFIG(appConfig);
                }
            };

            this.initProm = initPromFunc();
        }
        return this.initProm;
    }

    public async getAuthSettingsAsync(): Promise<AuthSettings | null> {
        await this.init();
        return this.getAuthSettings();
    }

    public async getAppConfigAsync(): Promise<AppConfig | null> {
        await this.init();
        return this.getAppConfig();
    }

    public getAuthSettings(): AuthSettings | null {
        return settingsModule.authSettings;
    }

    public getAppConfig(): AppConfig | null {
        return settingsModule.appConfig;
    }
}

const SettingsService = new SettingsServiceImpl();
export default SettingsService;
